import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SignIn.page.css';
import MainLogo from '../../../ui/components/MainLogo';

const Signin: React.FC = () => {
  // TODO Furqan, Create a state interface for this, 1 state variable
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError(''); // Clear error when user starts typing
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await fetch('/signin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error('Authentication failed. Please try again.');
      }

      const data = await res.json();
      localStorage.setItem('token', data.token); // Store JWT token
      navigate('/'); // Redirect to protected route
    } catch (error: any) {
      setError('Authentication failed. Please try again.');
    }
  };

  return (
    <div className="signin-container">
      <MainLogo nav={navigate} />
      <div className="signin-box">
        <h2 className="signin-title">Sign In</h2>
        {error && <p className="signin-error">{error}</p>}
        {/* TODO Furqan, remove the form, put in fields and a submit button  */}
        <form onSubmit={handleSubmit}>
          <input
            className="signin-input"
            type="email"
            name="email"
            placeholder="abc@xyz.com"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            className="signin-input"
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <button className="signin-button" type="submit">
            Sign in
          </button>
        </form>
        <p className="signin-terms">
          Don't have an account? <a href="/signup">Sign Up</a>.
        </p>
        <p className="signin-terms">  {/* TODO, wait for changes from Himanshu to be merged in and double checked. */}
          <a href="/forgot-password">Forgot Password?</a>
        </p>
      </div>
    </div>
  );
};

export default Signin;
